// extracted by mini-css-extract-plugin
export var bodyRow = "_gn-d";
export var cardColumns = "_gn-e";
export var ellipsesOverflow = "_gn-2";
export var flatBottomCorners = "_gn-3";
export var flatTopCorners = "_gn-4";
export var headerActionsDropdown = "_gn-f";
export var headerBottomRow = "_gn-c";
export var headerTopRow = "_gn-b";
export var orderDetailsWrapper = "_gn-0";
export var orderInfoContainer = "_gn-1";
export var productDetails = "_gn-9";
export var productImage = "_gn-5";
export var responsiveTable = "_gn-8";
export var shipmentContainer = "_gn-a";
export var tableBottomLeft = "_gn-6";
export var tableBottomRight = "_gn-7";
export var trackingLink = "_gn-g";